import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
  markerImage: null,
  loading: false,
  error: null,
};

const selectedVillageMarker = createSlice({
  name: "selectedVillageMarker",
  initialState,
  reducers: {
    fetchSelectedVillageMarkerStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSelectedVillageMarkerSuccess(state, action) {
      console.log("fetchDataSuccess selectedMarker success");
      state.loading = false;
      state.data = action.payload
      console.log("fetchDataSuccess selectedMarker success data");
    },
    fetchSelectedVillageMarkerFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setSelectedMarkerImage(state, action) {
      state.loading = false;
      state.markerImage = action.payload
    },
    resetSelectedVillageMarker(state) {
      state.data = null;
      state.markerImage = null
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchSelectedVillageMarkerStart,
  fetchSelectedVillageMarkerSuccess,
  fetchSelectedVillageMarkerFailure,
  resetSelectedVillageMarker,
  setSelectedMarkerImage
} = selectedVillageMarker.actions;
export default selectedVillageMarker.reducer;
